
import Vue, { PropType } from 'vue';

// Services & types
import CandidateService from '~/services/CandidateService';
import { CandidateJobBuilderChangeEvent, commonProps, setupBuilder } from '~/utils/candidate';
import { CandidateJobBuilder } from '~/utils/candidate/CandidateJobBuilder';
import { ImportSection } from '~/services/types/import';

// Components
import SummaryForm from '../forms/SummaryForm.vue';
import ProfileModal from './ProfileModal.vue';
import ImportBox from '~/components/profile/components/ImportBox.vue';

export default Vue.extend({
    name: 'SummaryModal',
    components: { ProfileModal, SummaryForm, ImportBox },
    props: {
        show: {
            type: Boolean,
            required: true,
        },

        ...commonProps(),

        importSection: {
            type: Object as PropType<ImportSection | undefined>,
            required: false,
            default: undefined,
        },
    },
    data() {
        return {
            builder: null as CandidateJobBuilder | null,
            service: new CandidateService(),

            isLoading: false,
            hasUnsavedChanges: false,
        };
    },
    methods: {
        handleBuilderChange(evt: CandidateJobBuilderChangeEvent) {
            this.hasUnsavedChanges = !evt.empty;
        },
        async handleSave() {
            if (!this.builder || this.builder.isEmpty()) return;
            const request = this.builder.buildRequest();

            this.isLoading = true;
            await this.service
                .updateCandidateProfile(request)
                .then(() => {
                    this.isLoading = false;
                    this.$emit('close');
                })
                .catch(() => {
                    this.isLoading = false;
                });
            this.builder.reset();
        },
    },
    mounted() {
        const builder = setupBuilder.apply(this);
        builder.on('change', this.handleBuilderChange);
    },
    beforeDestroy() {
        if (this.builder) this.builder.off('change', this.handleBuilderChange);
    },
    watch: {
        show(val: boolean) {
            if (val && this.builder) {
                this.builder.reset();
            }
        },
    },
});
